import { render, staticRenderFns } from "./FeedbackUploadingMenu.vue?vue&type=template&id=c6786736"
import script from "./FeedbackUploadingMenu.vue?vue&type=script&lang=js"
export * from "./FeedbackUploadingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports